 <div class="modal-container">
    <div *ngIf="pageType === 'mother_maiden_name'">
        <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
          <button *ngIf="!pageType === 'final_success'" class="float-end" mat-icon-button mat-dialog-close aria-label="Close dialog" [mat-dialog-close] tabindex="-1">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <p class="mat-error mb-5 px-3">Please enter your mother’s maiden name (or other password) to save your application to continue.
            You must enter a password or your progress will not be saved.</p>
        <form [formGroup]="formInput" class="px-3">
                <mat-form-field  class="w-100 mb-3">
                    <mat-label>Mother's maiden name / Password</mat-label>
                  <input [type]="hide2 ? 'password' : 'text'" matInput placeholder=""
                    formControlName='mother_maiden_name' [errorStateMatcher]="errorMatcherNew" required>
                  <span mat-icon-button matSuffix (click)="hide2 = !hide2" [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide">
                    <mat-icon class='eyeview me-3'>{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </span>
                  <mat-error *ngIf="formInput.get('mother_maiden_name').errors?.required">Enter Mother's maiden name
                  </mat-error>
                </mat-form-field>

                <mat-form-field  class="w-100 mb-3" [ngClass] = "{'error-mat-undeline': confirmError}">
                    <mat-label>Confirm mother's maiden name / Password</mat-label>
                  <input matInput type="password" [type]="hide3 ? 'password' : 'text'" placeholder=""
                    formControlName='confirm_mother_maiden_name' [errorStateMatcher]="errorMatcherCon" (keydown.enter)="submit(); $event.preventDefault();" required>
                  <span mat-icon-button matSuffix (click)="hide3 = !hide3" [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide">
                    <mat-icon class='eyeview me-3'>{{hide3 ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </span>
                  <div class="error-mat" *ngIf="confirmError">Confirm Mother's maiden name</div>
                  <mat-error *ngIf="formInput.hasError('ConfirmpasswordsDoNotMatch')">Mother's maiden name and confirm mother's maiden name should be same
                  </mat-error>
                </mat-form-field>
            <button class="float-end mb-3" mat-stroked-button (click)="close()">Close</button>
            <button class="float-end me-3 mb-3" mat-raised-button type="submit" [disabled]="!this.formInput.valid" (click)="submit()">Submit</button>

        </form>
    </div>

    <div *ngIf="pageType === 'app_in_progress'">
      <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
        <button class="float-end mt-2 me-2" mat-icon-button mat-dialog-close aria-label="Close dialog" (click)="goToHome()"> <mat-icon>close</mat-icon>
        </button>
        </div>
        <h4>An application of same type is already in progress using this email ID. Please check your email for details and either continue with the existing application or delete it and proceed with a new one.</h4>
        <button class="me-4 pt-2 mb-4 float-end" mat-raised-button (click)="goToHome()">OK</button>
    </div>

    <div *ngIf="pageType === 'email_verified'">
      <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
        <button class="float-end mt-2 me-2" mat-icon-button mat-dialog-close aria-label="Close dialog" (click)="goToHome()"> <mat-icon>close</mat-icon>
        </button>
        </div>
        <h4>The verification link has either expired or has been successfully verified.</h4>
        <button class="float-end" mat-raised-button (click)="goToHome()">OK</button>
    </div>

    <div *ngIf="pageType === 'cancel_application'">
        <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
          <button class="float-end" mat-icon-button mat-dialog-close aria-label="Close dialog" (click)="close()"> <mat-icon class="">close</mat-icon>
          </button>
<!--        <button mat-icon-button (click)="close()" class="mb-2">-->
<!--            <mat-icon>close</mat-icon>-->
<!--        </button>-->
        </div>
        <form [formGroup]="cancelForm" class="mx-3">
            <textarea class="border-radius w-100 p-2" type="textarea" rows="4" maxlength="256" formControlName="reason" required></textarea>

            <button class="float-end ms-3 mb-3 mt-3" mat-stroked-button (click)="close()">Close</button>
            <button class="float-end mb-3 mt-3" mat-raised-button type="submit" (click)="cancelApp()">Submit</button>

        </form>
    </div>

    <div *ngIf="pageType === 'PERMISSION_DENIED'">
        <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
        </div>
      <h4 class="px-3 mt-2 h5 mb-4">{{message}} <a [href]="helpUrl" target="_blank" style="text-decoration:none;"> Click here </a>for easy step-by-step instructions.</h4>
        <button class="float-end me-4 pt-1 mb-4" mat-raised-button (click)="goToHome()">OK</button>
    </div>

    <div *ngIf="pageType === 'POSITION_UNAVAILABLE'">
        <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
        </div>
      <h4 class="px-3 mt-2 h5 mb-4">{{message}} <a [href]="helpUrl" target="_blank" style="text-decoration:none;"> Click here </a>for easy step-by-step instructions.</h4>
        <button class="float-end me-4 pt-1 mb-4" mat-raised-button (click)="goToHome()">OK</button>
    </div>

    <div *ngIf="pageType === 'TIMEOUT'">
       <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
        </div>
      <h4 class="px-3 mt-2 h5 mb-4">{{message}}</h4>
        <button class="float-end me-4 pt-1 mb-4" mat-raised-button (click)="goToHome()">OK</button>
    </div>

    <div *ngIf="pageType === 'Error'">
        <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
        </div>
      <h4 class="px-3 mt-2 h5 mb-4">{{message}}</h4>
        <button class="float-end me-4 pt-1 mb-4" mat-raised-button (click)="goToHome()">OK</button>
    </div>

    <div *ngIf="pageType === 'FULL_VIEW_IMAGE'">
       <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
         <button class="float-end" mat-icon-button mat-dialog-close aria-label="Close dialog" (click)="close()"> <mat-icon class="ms-4">close</mat-icon>
         </button>
        </div>
        <img class="full-image" src="{{siteImageUrl}}" alt="{{siteImageName}}" />
        <button class="float-end mt-4" mat-raised-button (click)="goToHome()">OK</button>
    </div>

    <div *ngIf="pageType === 'final_success'">
        <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
        </div>
      <h4 class="px-3 mt-2 h5 mb-4">{{message}}</h4>
      <button class="float-end me-4 pt-1 mb-4" mat-raised-button (click)="goToStandardcWeb()">OK</button>
    </div>

    <div *ngIf="pageType === 'saveApplication'">
        <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
        </div>
      <h4 class="px-3 mt-2 h5 mb-4">{{message}}</h4>
      <button class="float-end me-4 pt-1 mb-4" mat-raised-button (click)="goToHome()">OK</button>
    </div>

    <div *ngIf="pageType === 'certification_signature'">
       <div class="modal-header">
        <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
         <button class="float-end" mat-icon-button mat-dialog-close aria-label="Close dialog" (click)="close()"> <mat-icon>close</mat-icon>
         </button>
        </div>
        <label class="certification-scroll mx-3" [innerHTML]="certification"></label>
        <form [formGroup]="signatureForm" class="mx-3">
        <div class="form-check mt-3 mb-3">
            <input class="form-check-input" type="checkbox" formControlName="iconfirm" required>
            <label class="form-check-label" for="iconfirm">I confirm<span class="text-danger">*</span></label>
            <div *ngIf="signatureForm.get('iconfirm')?.invalid" class="text-danger small">
                I confirm is required.
              </div>
        </div>

    </form>
        <p class="mx-3" style="font-weight: bold;">Signature</p>
        <div class="signature-container mx-3 mb-5">
            <canvas #signaturePadCanvas></canvas>
            <label class="mt-4 mb-3">Name: {{applicant_name}}</label>
            <div class="mb-5">
              <button type="button" mat-raised-button class="bg_danger text-white" (click)="clearSignature()">Clear</button>
              <button type="button" class="ms-4" mat-raised-button (click)="triggerUpload()">
                Submit
              </button>
              <button class="float-end" mat-stroked-button (click)="close()">Cancel</button>
            </div>
          </div>
        <!-- <app-custom-signature (signatureSaved)="onSignatureSaved($event)" (signatureCleared)="onSignatureCleared()"></app-custom-signature> -->


    </div>

    <div *ngIf="pageType === 'terms_conditions'">
        <div class="modal-header">
            <span class="ms-3 mt-3 h5">{{pageTitle}}</span>
        </div>
<!--      <span *ngIf="pageType === 'terms_conditions'" class="col-12 ms-4 fs-5 mb-4">{{pageTitle}}</span>-->
        <label class="terms-scroll mx-3" [innerHTML]="terms_conditions"></label>
        <form [formGroup]="termsForm" class="mx-3">
            <div class="form-check mt-3 mb-3">
                <input class="form-check-input" type="checkbox" formControlName="terms_check" required>
                <label class="form-check-label" for="terms_check">I have read and agree to the terms above<span class="text-danger">*</span></label>
            </div>
        </form>
              <button [disabled]="termsForm?.get('terms_check')?.invalid" class="float-end me-4 mb-4" mat-raised-button (click)="startApplication()">Start Application</button>
    </div>

<!--</mat-dialog-content>-->
 </div>
